// extracted by mini-css-extract-plugin
export default {"wrapper":"raa","container":"saa","image":"taa","info":"uaa","title":"vaa","note":"waa","product":"xaa","product_img":"yaa","description":"zaa","name":"Aaa","whybtn":"Baa","buttons":"Caa"};
    if(module.hot) {
      // 1715188240802
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  